export const LoadingButton = ({
    onClick,
    estaCargando,
    text = "Registrar",
    isFormSubmit = false // Por defecto es "false" si no lo especificas
  }) => {
    return (
      <div className="mt-4 flex">
        <button
          type={isFormSubmit ? "submit" : "button"}
          onClick={isFormSubmit ? undefined : onClick}
          className="mx-auto p-2 px-4 rounded-md bg-yellow-500 transition-all 
            hover:bg-yellow-600 text-white font-medium text-lg"
          disabled={estaCargando}
        >
          {estaCargando ? (
            <span className="flex items-center">
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-50"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
              Cargando...
            </span>
          ) : (
            text
          )}
        </button>
      </div>
    );
  };
  